<template>
  <footer class="site-footer">
    <div class="site-footer__flame" aria-hidden="true"></div>

    <div class="app-container">
      <div class="site-footer__grid">
        <div class="site-footer__brand-col">
          <BrandLogo size="md" />
          <p class="site-footer__tagline">
            {{ $t('footer.tagline') }}
          </p>
        </div>

        <nav class="site-footer__col" :aria-label="$t('footer.quickLinks')">
          <h2 class="site-footer__heading">{{ $t('footer.explore') }}</h2>
          <router-link to="/" class="site-footer__link">{{ $t('nav.home') }}</router-link>
          <router-link to="/detail" class="site-footer__link">{{ $t('nav.tournaments') }}</router-link>
          <router-link to="/about-us" class="site-footer__link">{{ $t('nav.about') }}</router-link>
          <router-link to="/privacy-policy" class="site-footer__link">{{ $t('nav.privacyPolicy') }}</router-link>
        </nav>

        <div class="site-footer__col">
          <h2 class="site-footer__heading">{{ $t('footer.contact') }}</h2>
          <a href="mailto:info@arenasportdigital.id" class="site-footer__link">
            <i class="bi bi-envelope" aria-hidden="true"></i> info@arenasportdigital.id
          </a>
          <span class="site-footer__text">
            <i class="bi bi-geo-alt" aria-hidden="true"></i> Indonesia
          </span>
        </div>

        <div class="site-footer__col">
          <h2 class="site-footer__heading">{{ $t('footer.appearance') }}</h2>
          <div class="site-footer__prefs">
            <LanguageSwitcher />
            <ThemeToggle />
          </div>
        </div>
      </div>

      <div class="site-footer__bottom">
        <p class="site-footer__copy">
          &copy; {{ year }} {{ $t('common.appName') }}. {{ $t('footer.rights') }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import ThemeToggle from '@/components/ui/ThemeToggle.vue';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher.vue';
import BrandLogo from '@/components/ui/BrandLogo.vue';

export default {
  name: 'MainFooter',
  components: { ThemeToggle, LanguageSwitcher, BrandLogo },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.site-footer {
  position: relative;
  background-color: var(--bg-surface);
  border-top: 1px solid var(--border-subtle);
  padding-block: var(--space-16) var(--space-6);
  margin-top: auto;
}

/* Garis api tipis di tepi atas — penanda merek yang tenang */
.site-footer__flame {
  position: absolute;
  top: -1px; left: 0; right: 0;
  height: 2px;
  background: var(--grad-flame);
  opacity: 0.85;
}

.site-footer__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-10);
}

@media (min-width: 640px) { .site-footer__grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 992px) { .site-footer__grid { grid-template-columns: 2fr 1fr 1.4fr 1fr; } }

.site-footer__brand-col { display: flex; flex-direction: column; gap: var(--space-4); align-items: flex-start; }

.site-footer__tagline {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-secondary);
  max-width: 34ch;
  line-height: 1.65;
}

.site-footer__col { display: flex; flex-direction: column; gap: var(--space-3); }

.site-footer__heading {
  margin: 0 0 var(--space-1);
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-muted);
}

.site-footer__link,
.site-footer__text {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  transition: color var(--transition-fast), transform var(--transition-fast);
}

.site-footer__link:hover { color: var(--text-brand); transform: translateX(3px); }
.site-footer__link i, .site-footer__text i { color: var(--accent); }

.site-footer__prefs { display: flex; align-items: center; gap: var(--space-2); }

.site-footer__bottom {
  margin-top: var(--space-10);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
}

.site-footer__copy {
  margin: 0;
  font-size: var(--text-xs);
  color: var(--text-muted);
  text-align: center;
}
</style>
